import { SiteLocale } from '@graphql/generated';
import { COUNTRY_CODE_KEY } from '@shared/constants';
import { localStorageGetItem } from './local-storage';

const CACHE_KEY = 'shippingMessagesCache';
const CACHE_DURATION_MS = 60 * 60 * 1000; // 1 ora

const loadShippingMessages = async (): Promise<
  Record<string, Record<string, Record<SiteLocale, string>>>
> => {
  const cachedData = sessionStorage.getItem(CACHE_KEY);
  const cacheTimestamp = sessionStorage.getItem(`${CACHE_KEY}_timestamp`);

  // Check if the cache exists and is still valid
  if (
    cachedData &&
    cacheTimestamp &&
    Date.now() - parseInt(cacheTimestamp, 10) < CACHE_DURATION_MS
  ) {
    return JSON.parse(cachedData);
  }

  const data = await fetch('/api/shipping-message', {
    cache: 'force-cache',
    next: {
      revalidate: 60 * 60 * 1000, // 1 hour
    },
  });

  const json = await data.json();
  sessionStorage.setItem(CACHE_KEY, JSON.stringify(json));
  sessionStorage.setItem(`${CACHE_KEY}_timestamp`, Date.now().toString());

  return json;
};

export const getShippingMessage = async (locale: SiteLocale): Promise<string | null> => {
  let message: string | null = null;
  try {
    const countryCode = localStorageGetItem(COUNTRY_CODE_KEY) || '';

    const shippingMessages = await loadShippingMessages();
    const a = shippingMessages?.[countryCode];
    if (!a) {
      return message;
    }
    const now = new Date();
    Object.entries(a).forEach(([d, labels]) => {
      const [from, to] = d.split('|');
      if (!message && new Date(from) <= now && now <= new Date(to)) {
        message = labels[locale];
      }
    });
  } catch (e) {
    console.error('getShippingMessage', e);
  }

  return message;
};
